import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Exercise } from "../models/exercise.model";
import { CurrentExercise } from "../models/current-exercise.model";

export namespace ExerciseActions {

  @logDispatcher
  export class GetExercises {
    static readonly type = '[Exercise] GetExercises';
    constructor() {}
  }

  @logDispatcher
  export class GetExercisesSuccess {
    static readonly type = '[Exercise] GetExercisesSuccess';
    constructor(public exercises: Exercise[]) {}
  }

  @logDispatcher
  export class GetCurrentExercise {
    static readonly type = '[Exercise] GetCurrentExercise';
    constructor() {}
  }

  @logDispatcher
  export class GetCurrentExerciseSuccess {
    static readonly type = '[Exercise] GetCurrentExerciseSuccess';
    constructor(public exercise: CurrentExercise) {}
  }

  @logDispatcher
  export class SetSelectedExercise {
    static readonly type = '[Exercise] SetSelectedExercise';
    constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class CreateExercise {
    static readonly type = '[Exercise] CreateExercise';
    constructor(public startYear: number, public endYear: number) {}
  }

  @logDispatcher
  export class CreateExerciseSuccess {
    static readonly type = '[Exercise] CreateExerciseSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Exercise] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetExerciseDefaultState {
    static readonly type = '[Exercise] SetExerciseDefaultState';
    constructor() {}
  }
}
